import { render, staticRenderFns } from "./site_template_edit.vue?vue&type=template&id=03c13a63&scoped=true"
import script from "./site_template_edit.vue?vue&type=script&lang=ts"
export * from "./site_template_edit.vue?vue&type=script&lang=ts"
import style0 from "./site_template_edit.vue?vue&type=style&index=0&id=03c13a63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c13a63",
  null
  
)

export default component.exports